import React   from 'react' ;
import PageCh18_t1 from './pageCh18_t1';
import PageCh18_t2 from './pageCh18_t2';
import pageCh18_t3 from './pageCh18_t3';
import PageCh18_t3 from './pageCh18_t3';
const   PageCh18 = ()=>{
     
       
    return (
      <>  <hr/> 
      <h1 className="m-2" >PageCh18  (chapter 18 - Diving into Redux (An Alternative To The Context API))</h1>
       <PageCh18_t1 /> 
       <PageCh18_t3 />   
       <PageCh18_t2 />    
          
          
      </>
    )
     
} 
export default PageCh18
